/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Col, Row, Typography } from 'antd';

import { ChannelField } from '@molecules';
import { Block, Button, Input, Select } from '@atoms';

import { CHANNEL_INITS, CHANNEL_FIELDS } from './constants';
import Form from '../Form';

import s from './styles.module.less';

const AddChannelForm = ({ onSubmit, initialValues: initData, buttons, className, handleClose }) => {
  const [form] = Form.useForm(CHANNEL_FIELDS);

  const initialValues = React.useMemo(() => form.deserialize(initData || CHANNEL_INITS), [form, initData]);

  const [time, setTime] = React.useState(deserializeTime(initialValues[CHANNEL_FIELDS.TIME.name]));

  const handleFinish = React.useCallback(
    (value) => {
      onSubmit({ ...value, time: serializeTime(time) });
      form.resetFields();

      handleClose();
    },
    [form, onSubmit, handleClose, time],
  );

  const onTimeChange = React.useCallback(
    (e, idx) => {
      const newArr = time;
      newArr[idx] = { ...newArr[idx], [e.target.name]: e.target.value };
      setTime(newArr);
    },
    [time, setTime],
  );

  const handleAddNewTime = React.useCallback(() => {
    setTime([...time, { from: '10:00', to: '11:00' }]);
  }, [time, setTime]);

  const DateBlock = React.useCallback(() => {
    return (
      <>
        <Typography>Time</Typography>
        <Block spaced className={s.timeContainer}>
          {time.map((itm, idx) => (
            <div className={s.timeRow}>
              From:
              <Input
                onChange={(e) => onTimeChange(e, idx)}
                className={s.timeInput}
                defaultValue={itm.from}
                name="from"
              />
              To:
              <Input onChange={(e) => onTimeChange(e, idx)} className={s.timeInput} defaultValue={itm.to} name="to" />
            </div>
          ))}
          <div>
            <Button type="primary" onClick={handleAddNewTime}>
              ADD TIME
            </Button>
          </div>
        </Block>
      </>
    );
  }, [time, onTimeChange, handleAddNewTime]);

  return (
    <Form
      onSerializedFinish={handleFinish}
      initialValues={initialValues}
      className={className}
      labelAlign="left"
      layout="vertical"
      colon={false}
      form={form}
    >
      {buttons && <Typography.Text level={3}>Edit Channel</Typography.Text>}
      <Row>
        <Col flex="1">
          <Row>
            <Col flex="1">
              <Form.Item {...CHANNEL_FIELDS.CATEGORY}>
                <Select {...CHANNEL_FIELDS.CATEGORY}>
                  {CHANNEL_FIELDS.CATEGORY.options.map((option) => (
                    <Select.Option key={option.value} value={option.value}>
                      {option.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <ChannelField {...CHANNEL_FIELDS.CHANNEL} wrapperCol={{ span: 24 }} />
            </Col>
          </Row>

          <DateBlock />

          <Row>
            <Col flex="1" gutter={10}>
              {buttons ? (
                buttons({ onSubmit: form.submit })
              ) : (
                <>
                  <Button type="primary" style={{ minWidth: 200, marginRight: 20 }} onClick={form.submit}>
                    SAVE
                  </Button>
                  <Button onClick={handleClose}>CANCEL</Button>
                </>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default AddChannelForm;

function serializeTime(_time) {
  return _time.map((itm) => `${itm.from}-${itm.to}`);
}

function deserializeTime(_time) {
  return _time?.length
    ? _time.map((itm) => {
        const from = itm.split('-')[0];
        const to = itm.split('-')[1];
        return { from, to };
      })
    : [{ from: '', to: '' }];
}
